import { DataSourceCategoryViewComponent } from './components/data-source-category-view/data-source-category-view.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './modules/material.module';
import { RadioBarChartComponent } from './components/radio-bar-chart/radio-bar-chart.component';
import { NgApexchartsModule } from 'ng-apexcharts';
import { TinyMceCommentComponent } from './components/tiny-mce-comment/tiny-mce-comment.component';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';
import { environment } from 'src/environments/environment';
import { FormsModule } from '@angular/forms';
import { CalibrationSetAttributesIconsComponent } from './components/attributes/calibration-set-attributes-icons/calibration-set-attributes-icons.component';
import { EntityAttributeIconComponent } from './components/attributes/entity-attribute-icon/entity-attribute-icon.component';
import { MatIconModule } from '@angular/material/icon';
import { AttributesButtonComponent } from './components/attributes/attributes-button/attributes-button.component';
import { AttributesPopupComponent } from './components/attributes/attributes-popup/attributes-popup.component';
import { LinkAttributeListComponent } from './components/attributes/link-attribute-list/link-attribute-list.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { ObjectToTableComponent } from './components/object-to-table/object-to-table.component';
import { SpinnerComponent } from './components/spinner/spinner.component';
import { ReloadNAValueComponent } from './components/reload-na-value/reload-na-value.component';
import { SliderForThreadsComponent } from './components/slider-for-threads/slider-for-threads.component';
import { AccessDeniedComponent } from './components/access-denied/access-denied.component';
import { ProcessSmallSpinnerComponent } from './components/process-small-spinner/process-small-spinner.component';
import { UniversalPieChartComponent } from './components/universal-pie-chart/universal-pie-chart.component';
import { LabeledSliderComponent } from './components/labeled-slider/labeled-slider.component';
import { ActionButtonWithEmbeddedSpinnerComponent } from './components/action-button-with-embedded-spinner/action-button-with-embedded-spinner.component';
import { UniversalAreaChartComponent } from './components/universal-area-chart/universal-area-chart.component';
import { BooleanStatusComponent } from './components/boolean-status/boolean-status.component';
import { SelectedIndicatorComponent } from './components/selected-indicator/selected-indicator.component';

@NgModule({
    imports: [
        CommonModule,
        MaterialModule,
        NgApexchartsModule,
        EditorModule,
        FormsModule,
        MatIconModule,
        MatSlideToggleModule
    ],
    declarations: [
        ConfirmationDialogComponent,
        ObjectToTableComponent,
        SpinnerComponent,
        ReloadNAValueComponent,
        SliderForThreadsComponent,
        AccessDeniedComponent,
        ProcessSmallSpinnerComponent,
        RadioBarChartComponent,
        TinyMceCommentComponent,
        CalibrationSetAttributesIconsComponent,
        EntityAttributeIconComponent,
        AttributesButtonComponent,
        AttributesPopupComponent,
        LinkAttributeListComponent,
        UniversalPieChartComponent,
        LabeledSliderComponent,
        ActionButtonWithEmbeddedSpinnerComponent,
        UniversalAreaChartComponent,
        DataSourceCategoryViewComponent,
        BooleanStatusComponent,
        SelectedIndicatorComponent
    ],
    exports: [
        ObjectToTableComponent,
        SpinnerComponent,
        ReloadNAValueComponent,
        SliderForThreadsComponent,
        AccessDeniedComponent,
        ProcessSmallSpinnerComponent,
        RadioBarChartComponent,
        TinyMceCommentComponent,
        CalibrationSetAttributesIconsComponent,
        AttributesButtonComponent,
        LinkAttributeListComponent,
        UniversalPieChartComponent,
        LabeledSliderComponent,
        ActionButtonWithEmbeddedSpinnerComponent,
        UniversalAreaChartComponent,
        DataSourceCategoryViewComponent,
        BooleanStatusComponent,
        SelectedIndicatorComponent
    ],
    providers: [
        {
            provide: TINYMCE_SCRIPT_SRC,
            useValue:
                (environment as any).TINY_MCE_URL ||
                'https://cdn.tiny.cloud/1/kd1mxtjjzejgjzxzxpakk2laxh85d0favrex8jhxg1hpn9hu/tinymce/5/tinymce.min.js'
        }
    ]
})
export class SharedModule {}
